export default {
  zh_cn: {
    title: "账户信息",
    institutionName: "机构名称",
    vip: "订阅信息",
    password: "更改密码",
    oldPwd: "旧的密码",
    newPwd: "新的密码",
    repeatPwd: "重复密码",
    input: "输入",
    name: "账号名称",
    save: "保存",
    required: "此项必填",
    update: "修改",
    cancel: "取消",
    repeatError: "两次输入的密码不一致",
    fieldError: "密码仅支持字母、数字和_以及?符号",
    lengthError: "密码长度应在6-30之间",
    done: "密码已修改",
    subscriptionEndTime: "订阅结束时间",
    lastLoginTime: "上次登录时间",
    to: "到"
  },
  ZH_HK: {
    title: "賬戶信息",
    institutionName: "機構名稱",
    vip: "訂閱信息",
    password: "更改密碼",
    oldPwd: "舊的密碼",
    newPwd: "新的密碼",
    repeatPwd: "重復密碼",
    input: "輸入",
    name: "賬號名稱",
    save: "保存",
    required: "此項必填",
    update: "修改",
    cancel: "取消",
    repeatError: "兩次輸入的密碼不一致",
    fieldError: "密碼僅支持字母、數字和_以及?符號",
    lengthError: "密碼長度應在6-30之間",
    done: "密碼已修改",
    subscriptionEndTime: "訂閱結束時間",
    lastLoginTime: "上次登錄時間",
    to: "到"
  },
  EN: {
    title: "Account Information",
    institutionName: "Institution Name",
    vip: "Subscription Info",
    password: "Change Password",
    oldPwd: "Old Password",
    newPwd: "New Password",
    repeatPwd: "Repeat Password",
    input: "Enter",
    name: "Account Name",
    save: "Save",
    required: "This field is required",
    update: "Update",
    cancel: "Cancel",
    repeatError: "The two passwords do not match",
    fieldError: "Password only supports letters, numbers, underscore (_), and question mark (?)",
    lengthError: "Password must be between 6 and 30 characters long",
    done: "Password has been updated",
    subscriptionEndTime: "Subscription End Date",
    lastLoginTime: "Last Login Time",
    to: "to"
  },
  es: {
    title: "Información de la cuenta",
    institutionName: "Nombre de la institución",
    vip: "Información de suscripción",
    password: "Cambiar contraseña",
    oldPwd: "Contraseña anterior",
    newPwd: "Nueva contraseña",
    repeatPwd: "Repetir contraseña",
    input: "Ingresar",
    name: "Nombre de la cuenta",
    save: "Guardar",
    required: "Este campo es obligatorio",
    update: "Actualizar",
    cancel: "Cancelar",
    repeatError: "Las contraseñas no coinciden",
    fieldError:
      "La contraseña solo admite letras, números, guion bajo (_) y signo de interrogación (?)",
    lengthError: "La contraseña debe tener entre 6 y 30 caracteres",
    done: "La contraseña se ha actualizado",
    subscriptionEndTime: "Fecha de finalización de la suscripción",
    lastLoginTime: "Último inicio de sesión",
    to: "a"
  }
};
